export default __webpack_public_path__ + "static/blob-43-898d03ae676d7f7d29360f74b4a6ca64.svg";